<template>
  <ol>
    <li>
      Invite your friends using any of the methods here:
      <ol type="a">
        <li>We email them</li>
        <li>You email them with your personal invitation link</li>
        <li>Social sharing - Facebook or Twitter</li>
      </ol>
    </li>
    <li>Whenever your friend or family member signs up with FairView we record that you referred them.</li>
    <li>We add the {{referralReward}} reward to your friend's account immediately</li>
    <li>As soon as your friend has reached the minimum withdrawal amount in their account, we add the {{referralReward}} reward to your account.</li>
    <li>This offer is valid for one month</li>
  </ol>
</template>

<script>
import store from '@/store';

export default {
  computed: {
    referralReward() {
      return store.getters.referralReward;
    },
  },
};
</script>

<style lang="scss" scoped>
ol:not([type='a']) li {
  margin: 5px 0;
}
</style>